<template ref="refTemp">
  <div id="app" ref="refApp">
    <router-view ref="refMobile" :key="key" v-if="isMobile" name="mobile"></router-view>
    <router-view ref="refWeb" :key="key" v-if="isWeb"></router-view>
    <router-view ref="refAdmin" :key="key" v-if="isAdmin"/>
  </div>
</template>

<script>
import commonUI from '@/mixin/commonUI'

export default {
  name: 'App',
  components: {
  },
  mixins: [commonUI],
  data () {
    return {
      isAdmin: false,
      isWeb: false,
      isMobile: false
    }
  },
  computed: {
    key () {
      if (this.$route.path.startsWith('/admin')) {
        return 'admin'
      }
      return this.$route.name
    }
  },
  created () {
  },
  mounted () {
    const currentUrl = window.location.href
    if (currentUrl.indexOf('/admin') > 0) {
      this.isAdmin = true
      this.isWeb = false
      this.isMobile = false
    } else {
      if (currentUrl.indexOf('/single') > 0) {
        this.isAdmin = false
        this.isMobile = false
        this.isWeb = true
      } else {
        this.isAdmin = false
        this.isMobile = this.isCheckMobile()
        this.isWeb = !this.isMobile
      }
    }
  },
  methods: {
  }
}
</script>
